export const SAVE_USER_DATA = 'SAVE_USER_DATA';
export const SAVE_WALLET_DATA = 'SAVE_WALLET_DATA';

export const saveUserData = (userId: string, data:any, isConnected: boolean) => ({
  type: SAVE_USER_DATA,
  payload: { 
    userId: userId,
    isConnected: isConnected,
    isFirstTierAssociated: data.isFirstTierAssociated,
    isFirstTierOwner: data.isFirstTierOwner,
    isSecondTierAssociated: data.isSecondTierAssociated,
    isSecondTierOwner: data.isSecondTierOwner,
    isThirdTierAssociated: data.isThirdTierAssociated,
    isThirdTierOwner: data.isThirdTierOwner,
    isFourthTierAssociated: data.isFourthTierAssociated,
    isFourthTierOwner: data.isFourthTierOwner,
    isFifthTierAssociated: data.isFifthTierAssociated,
    isFifthTierOwner: data.isFifthTierOwner,
    savedDateInSeconds: data.savedDateInSeconds,
    canClaimDaily: data.canClaimDaily,
    isFounder: data.isFounder,
    FTStatus: data.FTStatus,
    BBRStatus: data.BBRStatus,
    canClaimBBR: data.canClaimBBR,
    dailyClaimsAmount: data.dailyClaimsAmount,
    manceAndLeemonStatus: data.manceAndLeemonStatus,
    isManceTierAssociated: data.isManceTierAssociated,
    isManceTierOwner: data.isManceTierOwner,
    isLeemonTierAssociated: data.isLeemonTierAssociated,
    isLeemonTierOwner: data.isLeemonTierOwner,
    isCardAssociated: data.isCardAssociated
 
}
});

export const saveWalletData = (isFakeWallet: boolean) => ({
  type: SAVE_WALLET_DATA,
  payload: { 
    isFakeWallet: isFakeWallet,
},
});
